import React, { useState, useEffect } from "react";
import { Label } from "reactstrap";
import isNoSignature from "../../files/ic_no_signature.svg";
import { deviceType } from "../../constants/general.constant.js";
import getDeviceType from "../../helpers/getDeviceTypeHelper.js";

const SignatureWithName = (props) => {
  const signature = props.signature;
  const name = props.name;
  const isBorder = props.isBorder;
  const style = props.style || {};
  const layoutStyle = props.layoutStyle || {};
  // Optional override for when no digital signature exists — e.g. patients who only ever
  // gave verbal consent (documented in their chart notes) never produce a signature image,
  // so the default "Signature could not be found!" placeholder would misleadingly read as
  // consent never having been obtained at all.
  const noSignatureMessage = props.noSignatureMessage;

  // A signature URL can exist but still fail to load (deleted file, bad path, etc.),
  // which would otherwise show a broken-image icon instead of a real fallback.
  const [imageFailed, setImageFailed] = useState(false);
  useEffect(() => {
    setImageFailed(false);
  }, [signature]);

  const hasSignature = !!signature && !imageFailed;

  let classes = "col-md-4 div-remove-padding";
  const device = getDeviceType();
  if(device === deviceType.tablet){
    classes = "col-md-12 div-remove-padding";
  }
  return (
    <div className={props.isCCMQuestion ? classes : ""}>
      {isBorder && (
        <>
          <div className="signature-layout remove-margin-right" style={layoutStyle}>
            {/* <p className="signature-title">Signature : </p> */}
            <div>
              {hasSignature && (
                <>
                  <div className="signature-display-image-layout" style={style}>
                    <img
                      src={signature}
                      className="signature-display-image"
                      onError={() => setImageFailed(true)}
                    />
                    <code>
                      <hr className="border-signature" />
                      <p className="signature-label"><i className="mdi mdi-account-circle signature-user-icon" />{name}</p>
                    </code>
                  </div>
                </>
              )}
              {!hasSignature && (
                <>
                  <div
                    className={`signature-display-image-layout-no-signature${noSignatureMessage ? " signature-no-signature-verbal" : ""}`}
                    style={style}
                  >
                    {noSignatureMessage ? (
                      <Label className="no-signature-found verbal-consent-documented">
                        {noSignatureMessage}
                      </Label>
                    ) : (
                      <>
                        <img className="no-signature"
                          src={isNoSignature}
                        />
                        <Label className="no-signature-found">
                          Signature could not be found!
                        </Label>
                      </>
                    )}
                    <code>
                      <hr className="border-signature" />
                      <p className="signature-label"><i className="mdi mdi-account-circle signature-user-icon" />{name}</p>
                    </code>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
      {!isBorder && (
        <>
          <div className="signature-layout remove-margin-right">
            <div>
              {hasSignature && (
                <>
                  <div className="signature-without-border">
                    <img
                      src={signature}
                      className="signature-display-image"
                      onError={() => setImageFailed(true)}
                    />
                    <code>
                      <hr className="border-signature" />
                      <p className="signature-label"><i className="mdi mdi-account-circle signature-user-icon" />{name}</p>
                    </code>
                  </div>
                </>
              )}
              {!hasSignature && (
                <>
                  <div className={`signature-without-border${noSignatureMessage ? " signature-no-signature-verbal" : ""}`}>
                    {noSignatureMessage ? (
                      <Label className="no-signature-found verbal-consent-documented">
                        {noSignatureMessage}
                      </Label>
                    ) : (
                      <>
                        <img className="no-signature"
                          src={isNoSignature}
                        />
                        <Label className="no-signature-found">
                          Signature could not be found!
                        </Label>
                      </>
                    )}
                    <code>
                      <hr className="border-signature" />
                      <p className="signature-label"><i className="mdi mdi-account-circle signature-user-icon" />{name}</p>
                    </code>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SignatureWithName;
